<template>
  <b-card no-body >
    <b-card-body>
      <div class="d-flex justify-content-between  flex-wrap">
        <!-- Registar Empresa  -->
        <b-form-group
            label-for="filterInput"
            class="mb-0"
        >
          <b-button
              variant="gradient-primary"
              size="sm"
              class="mr-1"
              @click="traerEmpresas"
          >
            <feather-icon
                icon="RefreshCwIcon"
            />
          </b-button>

          <b-button
              variant="gradient-success"
              size="sm"
              @click="descargarFile()"
          >
            <feather-icon
                icon="PlusIcon"
                class="mr-50"
            />
            <span class="align-middle">Exportar</span>
          </b-button>
        </b-form-group>

        <!-- filter -->
        <b-form-group
            label-for="filterInput"
            class="mb-0"
        >
          <b-input-group size="sm">
            <b-form-input
                id="filterInput"
                v-model="filter"
                type="search"
                placeholder="Buscar"
            />
            <b-input-group-append>
              <b-button
                  :disabled="!filter"
                  @click="filter = ''"
              >
                Borrar
              </b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>

      </div>
    </b-card-body>

    <b-table
        hover
        responsive
        class="position-relative"
        :per-page="perPage"
        :current-page="currentPage"
        :items="items"
        :fields="fields"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :sort-direction="sortDirection"
        :filter="filter"
        :filter-included-fields="filterOn"
        @filtered="cPaginacion"
        :busy="loading"
        show-empty
        empty-text="No se encontraron datos en esta tabla."
    >
      <template #table-busy>
        <div class="text-center text-dark my-1">
          <b-spinner class="align-middle"></b-spinner> &emsp;
          <strong>Obteniendo datos...</strong>
        </div>
      </template>

      <template #cell(estado)="data">
        <b-badge :variant="status[1][data.value]">
          {{ status[0][data.value] }}
        </b-badge>
      </template>

      <template #cell(area)="data">
        <span style="white-space: nowrap">{{ data.value }}</span>
      </template>

      <template #cell(unidad)="data">
        <span style="white-space: nowrap">{{ data.value }}</span>
      </template>

      <template #cell(tipo_concepto)="data">
        <span style="white-space: nowrap">{{ data.value }}</span>
      </template>

      <template #cell(acciones)="data">
        <div class="text-nowrap">
          <feather-icon
              :id="`btn_${data.item.id}_eliminar`"
              icon="Trash2Icon"
              size="16"
              @click="eliminarRegistro(data.item.fecha_movil, data.item.hora_movil, data.item.type_evaluacion, data.item.dni, data.item.nombres, data.item.area, data.item.puesto, data.item.nombres_jefe, data.item.escuela, data.item.unidad, data.item.concepto, data.item.tipo_concepto, data.item.nombres_evaluador, data.item.canal, data.item.estado, data.item.fecha_text, data.item.hora_text, data.item.etapa, data.item.campo)"
          />
          <b-tooltip
              title="Eliminar registro"
              :target="`btn_${data.item.id}_eliminar`"
          />

        </div>
      </template>

    </b-table>

    <b-card-body class="d-flex justify-content-between flex-wrap pt-0">
      <!-- page length -->
      <b-form-group
          label="Mostrar"
          label-cols="5"
          label-align="left"
          label-size="sm"
          label-for="sortBySelect"
          class="text-nowrap mb-md-0 mr-1"
      >
        <b-form-select
            id="perPageSelect2"
            v-model="perPage"
            size="sm"
            inline
            :options="pageOptions"
        />

      </b-form-group>

      <!-- pagination -->
      <div>
        <b-pagination
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            first-number
            last-number
            prev-class="prev-item"
            next-class="next-item"
            class="mb-0"
        >
          <template #prev-text>
            <feather-icon
                icon="ChevronLeftIcon"
                size="18"
            />
          </template>
          <template #next-text>
            <feather-icon
                icon="ChevronRightIcon"
                size="18"
            />
          </template>
        </b-pagination>
      </div>
    </b-card-body>

    <b-modal
        id="modalRegistro"
        v-model="estadoModal"
        :title="infoModal.title"
        :ok-title="infoModal.boton"
        cancel-variant="outline-secondary"
        cancel-title="Cancelar"
        @hidden="resetModal"
        @ok="okModal"
        centered
    >
      <form
          ref="form"
          @submit.stop.prevent="enviarFormulario"
      >
        <b-row>
          <b-col md="6">
            <b-form-group
                :state="validacion"
                label="Código"
                label-for="codigo"
                invalid-feedback="Código es requerido"
            >
              <b-form-input
                  id="codigo"
                  placeholder="Código"
                  v-model="codigo"
                  :state="validacion"
                  required
              />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group
                :state="validacion"
                label="Nombre"
                label-for="nombre"
                invalid-feedback="Nombre es requerido"
            >
              <b-form-input
                  id="nombre"
                  placeholder="Nombre"
                  v-model="nombre"
                  :state="validacion"
                  required
              />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group
                :state="validacion"
                label="Descripción"
                label-for="descrip"
                invalid-feedback="Descripción es requerido"
            >
              <b-form-input
                  id="descrip"
                  placeholder="Descripción"
                  v-model="descrip"
                  :state="validacion"
                  required
              />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group
                label="Estado"
                label-for="estado"
                invalid-feedback="Código AGV es requerido"
            >
              <v-select
                  id="estado"
                  v-model="estado"
                  label="text"
                  :options="estados"
              />
            </b-form-group>
          </b-col>
        </b-row>
      </form>
    </b-modal>
  </b-card>
</template>

<script>
import axiosIns from '../../../libs/axios'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

import {
  BCard,
  BTable,
  BAvatar,
  BBadge,
  BFormGroup,
  BFormSelect,
  BPagination,
  BInputGroup,
  BFormInput,
  BInputGroupAppend,
  BButton,
  BCardBody,
  BTooltip,
  BModal,
  VBModal,
  BListGroup,
  BListGroupItem,
  BRow,
  BCol, BSpinner
} from 'bootstrap-vue'
import axios from "axios";
import qs from 'qs'

export default {
  components: {
    BCard,
    BTable,
    BAvatar,
    BBadge,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BButton,
    BCardBody,
    BTooltip,
    BModal,
    VBModal,
    BListGroup,
    BListGroupItem,
    BRow,
    BCol,
    vSelect,
    ToastificationContent,
    BSpinner,
  },
  directives: {
    'b-modal': VBModal,
    Ripple,
  },
  data() {
    return {
      perPage: 5,
      pageOptions: [5, 10, 15],
      totalRows: 1,
      currentPage: 1,
      sortBy: '',
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      filterOn: [],
      estadoModal: false,
      infoModal: {
        title: '',
        boton: '',
      },
      fields: [
        /*
        {
          key: 'id',
          label: 'Id',
          sortable: true
        },

        {
          key: 'cod',
          label: 'Código',
          sortable: true
        },
        */
        {
          key: 'nombres',
          label: 'Trabajador',
          sortable: true
        },
        {
          key: 'dni',
          label: 'DNI',
          sortable: true
        },
        {
          key: 'area',
          label: 'ÁREA',
          sortable: true
        },
        {
          key: 'puesto',
          label: 'PUESTO',
          sortable: true
        },
        {
          key: 'nombres_jefe',
          label: 'JEFE',
          sortable: true
        },
        {
          key: 'fecha_text',
          label: 'FECHA',
          sortable: true
        },
        {
          key: 'hora_text',
          label: 'HORA',
          sortable: true
        },
        {
          key: 'nombres_evaluador',
          label: 'EVALUADOR',
          sortable: true
        },
        {
          key: 'escuela',
          label: 'ESCUELA',
          sortable: true
        },
        {
          key: 'unidad',
          label: 'UNIDAD   ',
          sortable: true
        },
        {
          key: 'canal',
          label: 'CANAL',
          sortable: true
        },
        {
          key: 'tipo_concepto',
          label: 'TIPO',
          sortable: true
        },
        {
          key: 'estado',
          label: 'Estado',
          sortable: true
        },
        {
          key: 'acciones'
        },
      ],
      items: [],
      status: [
        {
          1: 'Activo',
          0: 'Inactivo',
        },
        {
          1: 'light-success',
          0: 'light-danger',
        }
      ],
      validacion: null,
      estados: [
        {value: 0, text: "Activo"},
        {value: 1, text: "Inactivo"}
      ],
      codigo: '',
      descrip: '',
      nombre: '',
      estado: {value: 0, text: "Activo"},
      id: 0,
      tipo: 0,
      loading: false,
    }
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
          .filter(f => f.sortable)
          .map(f => ({
            text: f.label,
            value: f.key
          }))
    },
  },
  mounted() {
    this.traerEmpresas();
  },
  methods: {
    traerEmpresas(){
      var yo = this

      yo.loading = true;
      var config = {
        method: 'get',
        url: '/capacitacion/liderazgo_packing/todos/'
      };

      axiosIns(config)
      .then(function (response) {
        yo.items = response.data;
        yo.totalRows = yo.items.length
      })
      .catch(function (error) {
        console.log(error);
      }).finally(function (){
        yo.loading = false;
      });
    },

    cPaginacion(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },

    mostrarModal(tipo, id, codigo, descrip, nombre, estado){

      this.tipo = tipo
    //  this.estadoModal = true

      if (this.tipo === 1 ){
        this.infoModal.title = 'Registrar Empresa'
        this.infoModal.boton = 'Registar'
      }
      else if (this.tipo === 2 ){
        this.infoModal.title = 'Editar Empresa'
        this.infoModal.boton = 'Editar'

        this.id = id
        this.codigo = codigo
        this.descrip = descrip
        this.nombre = nombre

        this.estado = {value: parseInt(estado), text: estado === '0' ? 'Activo' : 'Inactivo'}
      }



    },
    enviarFile(){
      var yo = this
      this.loading = true
      var data = new FormData();
      data.append('file', this.archivo_excel)

      var config = {
        method: 'post',
        url: '/utilidades/archivo/cargar/',
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        data : data
      };

      axiosIns(config)
          .then(function (response) {
            if(response.status === 201){
              yo.$toast({
                component: ToastificationContent,
                props: {
                  title: 'Registro guardado',
                  icon: 'CheckIcon',
                  text: 'El envío de los registros se realizó satisfactoriamente.',
                  variant: 'success',
                },
              })
            }
          })
          .catch(function (error) {
            console.log(error);

            yo.$toast({
              component: ToastificationContent,
              props: {
                title: 'Error en el registro',
                icon: 'XIcon',
                text: 'Hubo un error en el registro, intentelo nuevamente en unos minutos.',
                variant: 'danger',
              },
            })
          })
          .finally(function () {
            yo.archivo_excel = null
            yo.loading = false
          })
      ;

    },
    descargarFile(){

      var yo = this

      var config = {
        method: 'post',
        url: 'https://prd-cloud.agvperu.com/dms/Jaspergen/exportExcelEvaluacionesPacking',
        headers: { }
      };
      axios(config)
          .then(function (response) {
            var content = JSON.stringify(response.data);
            console.log("Contenido1: "+content);
            window.location.href = 'https://prd-cloud.agvperu.com/dms/Jaspergen/downloadExcelJasperEvaluacionesPacking';
                if(content === "ok"){
                  yo.$toast({
                    component: ToastificationContent,
                    props: {
                      title: 'Archivo descargado',
                      icon: 'CheckIcon',
                      text: 'El archivo se descargó satisfactoriamente.',
                      variant: 'success',
                    },
                  })
                }

          })
          .catch(function (error) {
            console.log("error1: "+error);
          });


    },

    mostrarNotificacion(titulo, icono, texto, variante){
      this.$toast({
        component: ToastificationContent,
        props:{
          title: titulo,
          icon: icono,
          text: texto,
          variant: variante
        }
      },
      {
        timeout: 5000
      })
    },

    resetInfoModal() {
      this.infoModal.title = ''
      this.infoModal.boton = ''
      this.estadoModal = false
    },

    validarFormulario() {
      const valid = this.$refs.form.checkValidity()
      this.validacion = valid
      return valid
    },

    resetModal() {
      this.codigo = ''
      this.descrip = ''
      this.nombre = ''
      this.estado = {value: 0, text: "Activo"}
      this.validacion = null
      this.resetInfoModal()
    },

    okModal(bvModalEvt) {

      bvModalEvt.preventDefault()

      this.enviarFormulario()
    },

    enviarFormulario() {
      // Exit when the form isn't valid
      if (!this.validarFormulario()) {
        return
      }

      // Hide the modal manually
      this.$nextTick(() => {
        var yo = this

        var data = JSON.stringify({
          "cod": yo.codigo,
          "descrip": yo.descrip,
          "nombre": yo.nombre,
          "estado": yo.estado.value.toString()
        });

        var url = this.tipo === 1 ? '/configuracion/empresas/crear/' : '/configuracion/empresas/editar/'+this.id
        var metodo = this.tipo === 1 ? 'post' : 'patch'

        var config = {
          method: metodo,
          url: url,
          headers: {
            'Content-Type': 'application/json'
          },
          data : data
        };

        axiosIns(config)
            .then(function (response) {

              if (response.status === 201 || response.status === 200){
                yo.traerEmpresas();

                if (yo.tipo === 1){
                  yo.mostrarNotificacion('Registro creado', 'CheckIcon', 'La empresa ' + response.data.cod + ' ha sido registrado correctamente', 'success')
                }else{
                  yo.mostrarNotificacion('Registro modificado', 'CheckIcon', 'La empresa ' + yo.codigo + ' ha sido modificado correctamente', 'success')
                }

              }else{
                yo.mostrarNotificacion('Error', 'BellIcon', JSON.stringify(response.data).toString(), 'danger')
              }

            })
            .catch(function (error) {
              console.log(error);
              yo.mostrarNotificacion('Error en el registro', 'BellIcon', error.toString(), 'danger')
            });

        this.estadoModal = false
      })
    },

    eliminarRegistro(fecha_movil,hora_movil,type_evaluacion,dni,nombres,area,puesto,nombres_jefe,escuela,unidad,concepto,tipo_concepto,nombres_evaluador,canal,estado,fecha_text,hora_text,etapa,campo){
      var yo = this

      var codigo_delete =''+type_evaluacion+dni+nombres+area+puesto+nombres_jefe+escuela+unidad+concepto+tipo_concepto+nombres_evaluador+canal+estado+fecha_text+hora_text+etapa+campo;


      this.$swal({
        title: '¡Alerta!',
        text: "¿Seguro que quieres eliminar al trabajador " + nombres + " del ("+concepto+"). ?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Eliminar',
        cancelButtonText: 'Cancelar',
        reverseButtons: true,
        customClass: {
          confirmButton: 'btn btn-primary ml-1',
          cancelButton: 'btn btn-outline-danger',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          var qs = require('qs');

          var data = qs.stringify({
            'codigo_delete': codigo_delete,
            'valor': '6'
          });

          var config = {
            method: 'post',
            url: '/capacitacion/liderazgo_capac_trabajdores/eliminar/',
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded'
            },
            data : data
          };

          axiosIns(config)
              .then(function (response) {
                if (response.status === 204||response.status === 200){
                  yo.traerEmpresas();
                  yo.mostrarNotificacion('Registro eliminado', 'CheckIcon', 'El trabajador ha sido eliminado correctamente', 'success')
                }else{
                  yo.mostrarNotificacion('Error', 'BellIcon', JSON.stringify(response.data).toString(), 'danger')
                }
              })
              .catch(function (error) {
                yo.mostrarNotificacion('Error en el registro', 'BellIcon', error.toString(), 'danger')
              });
        }
      })
    }

  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
